import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { GradeType } from '@shared/enums/grade-type';
import { LessonPlanActionType } from '@shared/enums/lesson-type';
import { ProductType } from '@shared/enums/product-type';
import moment from 'moment';

import { ILessonSectionResponse, ILessonTab } from './lesson-section';
import { IEdGateStandardCollection } from './lesson-standard';

export interface ILessonPlanResponse {
  lessonDate: string;
  dayOfTheWeek: string;
  topicKey: string;
  unit: number;
  unitName: string;
  unitWeight: number;
  topicName: string;
  topicWeight: number;
  isSkipDay: boolean;
  isCurrentLesson: boolean;
  lessonHasMultipleDays: boolean;
  hasPreviousLesson: boolean;
  hasNextLesson: boolean;
  sections: ILessonSectionResponse[];
}

export interface ILessonPlan {
  lessonDate: moment.Moment;
  dayOfTheWeek: string;
  topicKey: string;
  unit: number;
  unitName: string;
  unitWeight: number;
  topicName: string;
  topicWeight: number;
  isSkipDay: boolean;
  isCurrentLesson: boolean;
  lessonHasMultipleDays: boolean;
  hasPreviousLesson: boolean;
  hasNextLesson: boolean;
  tabs: ILessonTab[];
  date?: string;
  formattedDate?: string;
  ngbDate?: NgbDateStruct;
}

export class LessonPlan implements ILessonPlan {
  lessonDate: moment.Moment = null;
  dayOfTheWeek: string = '';
  topicKey: string = '';
  unit: number = 1;
  unitName: string = '';
  unitWeight: number = 0;
  topicName: string = '';
  topicWeight: number = 0;
  isSkipDay: boolean;
  isCurrentLesson: boolean = false;
  lessonHasMultipleDays: boolean = false;
  hasPreviousLesson: boolean = false;
  hasNextLesson: boolean = false;
  tabs: ILessonTab[] = [];

  constructor(values: ILessonPlan) {
    this.lessonDate = values.lessonDate || null;
    this.dayOfTheWeek = values.dayOfTheWeek || '';
    this.topicKey = values.topicKey || '';
    this.unit = values.unit ?? 1;
    this.unitName = values.unitName || '';
    this.unitWeight = values.unitWeight || 0;
    this.topicName = values.topicName || '';
    this.topicWeight = values.topicWeight || 0;
    this.isSkipDay = values.isSkipDay || false;
    this.isCurrentLesson = values.isCurrentLesson || false;
    this.lessonHasMultipleDays = values.lessonHasMultipleDays || false;
    this.hasPreviousLesson = values.hasPreviousLesson || false;
    this.hasNextLesson = values.hasNextLesson || false;
    this.tabs = values.tabs || [];
  }

  get date(): string {
    return this.lessonDate?.format('YYYY-MM-DD');
  }

  get formattedDate(): string {
    return this.lessonDate?.format('M/D/YY');
  }

  get ngbDate(): NgbDateStruct {
    if (this.lessonDate) {
      return {
        year: this.lessonDate.year(),
        month: this.lessonDate.month() + 1,
        day: this.lessonDate.date(),
      };
    }
    return null;
  }
}

export interface ILessonPlanCollection {
  previousTopicKey: string;
  nextTopicKey: string;
  lessons: ILessonPlan[];
  externalStandards: IEdGateStandardCollection[];
  plannerStartDate: string;
  plannerEndDate: string;
}

export interface ILessonPlannerResponse {
  previousTopicKey: string;
  nextTopicKey: string;
  lessons: ILessonPlanResponse[];
  externalStandards: IEdGateStandardCollection[];
  plannerStartDate: string;
  plannerEndDate: string;
}

export interface ILessonPlanRequest {
  gradeType: GradeType | string;
  productType: ProductType;
  topicKey?: string;
  numberOfDays?: number;
  lessonDate?: string;
  lessonPlanAction: LessonPlanActionType;
}
